
  var _styles = {
  "bottom-slide-modal-closeBtn": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-end",
    "marginLeft": "auto",
    "marginRight": "0.26667rem"
  }
};



  module.exports = _styles;
  